import { PackageData } from '../../../types/gig/interfaces';

const MINIMUM_PACKAGE_PRICE_IN_CENTS = 10000; // 100 USD

/**
 * Checks if there is a package with id === 1 and price >= MINIMUM_PACKAGE_PRICE_IN_CENTS
 * @param packageList - Array of packages to check
 * @returns {boolean} true if package with id 1 exists and has price >= MINIMUM_PACKAGE_PRICE_IN_CENTS
 */
export const hasPackageWithIdOneAndMinimumPrice = (packageList?: PackageData[]): boolean => {
    if (!packageList || !Array.isArray(packageList)) {
        return false;
    }

    const packageWithIdOne = packageList.find((pkg) => pkg.id === 1);
    if (!packageWithIdOne) {
        return false;
    }

    return packageWithIdOne.price >= MINIMUM_PACKAGE_PRICE_IN_CENTS;
};
